import React from 'react';
import { Seo } from '../components/Seo';

const TODO = ({ children }) => (
  <span className="italic text-slate-400">{children}</span>
);

const Block = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="text-xl md:text-2xl font-bold text-slate-900 mb-3">{title}</h2>
    <div className="text-slate-600 leading-relaxed space-y-2">{children}</div>
  </section>
);

const MentionsLegales = () => {
  return (
    <main className="pt-28" data-testid="page-mentions-legales">
      <Seo
        title="Mentions légales | VIREO Rénovation"
        description="Mentions légales du site VIREO Rénovation, entreprise de rénovation à Paris et en Île-de-France."
        path="/mentions-legales"
      />
      <section className="bg-slate-900 py-14 md:py-16">
        <div className="container mx-auto px-4">
          <span className="text-emerald-400 font-semibold text-sm uppercase tracking-wider mb-3 block">
            Informations légales
          </span>
          <h1 className="text-4xl md:text-5xl font-bold text-white">Mentions légales</h1>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-3xl">
          <Block title="Éditeur du site">
            <p>
              Le site <strong>www.vireo-renovation.fr</strong> est édité par <strong>VIREO</strong>,
              entreprise de rénovation.
            </p>
            <p>Forme juridique : <TODO>(à compléter)</TODO></p>
            <p>Capital social : <TODO>(à compléter)</TODO></p>
            <p>Siège social : 29 rue Tronchet, 75008 Paris</p>
            <p>Téléphone : 01 85 09 71 25</p>
            <p>Email : devis@vireo-renovation.fr</p>
            <p>SIRET : <TODO>(à compléter)</TODO></p>
            <p>RCS / RM : <TODO>(à compléter)</TODO></p>
            <p>N° TVA intracommunautaire : <TODO>(à compléter)</TODO></p>
            <p>Directeur de la publication : <TODO>(à compléter)</TODO></p>
          </Block>

          <Block title="Activité">
            <p>
              VIREO est une entreprise générale de rénovation intervenant à Paris et en Île-de-France :
              rénovation complète, rénovation intérieure, rénovation énergétique, façade et isolation.
              VIREO est artisan et dispose d'une attestation officielle.
            </p>
          </Block>

          <Block title="Assurances">
            <p>
              Assurance responsabilité civile professionnelle et garantie décennale :
              <TODO> (assureur, n° de contrat et zone géographique couverte à compléter)</TODO>.
            </p>
          </Block>

          <Block title="Hébergement">
            <p>Le site est hébergé par : <TODO>(hébergeur et adresse à compléter)</TODO>.</p>
          </Block>

          <Block title="Propriété intellectuelle">
            <p>
              L'ensemble des contenus présents sur ce site (textes, images, logos, photographies de
              chantiers) est la propriété de VIREO ou de ses partenaires et est protégé par le droit
              d'auteur. Toute reproduction ou représentation, totale ou partielle, sans autorisation
              écrite préalable est interdite.
            </p>
          </Block>

          <Block title="Responsabilité">
            <p>
              Les informations diffusées sur ce site sont fournies à titre indicatif. VIREO s'efforce
              d'en assurer l'exactitude mais ne saurait être tenue responsable des erreurs ou omissions,
              ni de l'usage qui en est fait.
            </p>
          </Block>

          <Block title="Données personnelles">
            <p>
              Le traitement des données collectées via les formulaires du site est décrit dans notre{' '}
              <a href="/politique-confidentialite" className="text-emerald-700 font-medium hover:underline">
                politique de confidentialité
              </a>.
            </p>
          </Block>
        </div>
      </section>
    </main>
  );
};

export default MentionsLegales;
